import useReveal from "@/hooks/useReveal";

const strengths = [
  {
    icon: "ri-time-line",
    title: "16년 이상 시공경험",
    desc: "2010년 5월 1일 설립 이후 축적된 노하우와 검증된 시공 데이터베이스로 완성도 높은 결과를 보장합니다.",
  },
  {
    icon: "ri-medal-line",
    title: "전문건설업 등록업체",
    desc: "건설산업기본법에 따른 전문건설업체로서 법적 기준을 뛰어넘는 시공 기준을 유지합니다.",
  },
  {
    icon: "ri-heart-line",
    title: "장애인기업 인증",
    desc: "사회적 가치를 실현하는 장애인기업 인증업체로 공공기관 우선 협력사 자격을 보유합니다.",
  },
  {
    icon: "ri-government-line",
    title: "공공기관 시공 경험",
    desc: "부산시설공단, 교육청, 공공청사 등 다수의 공공 프로젝트를 성공적으로 완수했습니다.",
  },
];

export default function About() {
  const ref = useReveal<HTMLDivElement>();
  return (
    <section id="about" className="relative w-full py-24 md:py-32 bg-white overflow-hidden">
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-point-50/20 via-white to-white" />
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-point-50/12 via-transparent to-transparent rounded-full blur-3xl pointer-events-none" />
      <div className="w-full px-6 md:px-12 lg:px-16 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div ref={ref} className="reveal lg:col-span-5 relative pb-0 lg:pb-10">
            <div className="relative rounded-2xl overflow-hidden h-[320px] sm:h-[420px] lg:h-[560px]">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_b7575c20f7623b8e9557545e009733ff_04b0322d.jpg"
                alt="에폭시바닥 시공 현장을 점검하는 대표"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="hidden lg:block absolute -bottom-8 -right-4 md:-right-8 bg-navy-900 text-white px-8 py-6 rounded-xl">
              <div className="font-hero text-4xl md:text-5xl text-point-400">16+</div>
              <div className="text-xs uppercase tracking-widest text-white/70 mt-1">
                Years of Excellence
              </div>
            </div>
            <div className="lg:hidden mt-4 inline-flex items-center gap-4 bg-navy-900 text-white px-6 py-4 rounded-xl">
              <div className="font-hero text-3xl text-point-400">16+</div>
              <div className="text-xs uppercase tracking-widest text-white/70">Years of Excellence</div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-8 h-px bg-point-500"></span>
              <span className="text-point-600 text-xs font-semibold uppercase tracking-[0.3em]">
                About JI&amp;C
              </span>
            </div>
            <h2 className="font-hero text-navy-900 text-3xl md:text-5xl lg:text-6xl leading-tight mb-6">
              시공으로 증명하는
              <br />
              <span className="text-navy-700">기술력과 신뢰</span>
            </h2>
            <p className="text-neutral-600 text-base md:text-lg leading-relaxed mb-10 max-w-2xl">
              제이아이앤씨(JI&amp;C)는 2010년 5월 1일 설립 이후 에폭시바닥, 우레탄방수, 도장, 습식방수, 석공사, 실내건축분야에서
              400건 이상의 프로젝트를 수행한 전문건설업체입니다. 대기업 공장, 물류창고, 공공기관, 교육시설의
              까다로운 시공 기준을 통과하며 축적된 데이터와 인력이 우리의 진짜 자산입니다.
              전문 시공팀이 현장에서 직접 관리하며, 공사 전·후 모든 과정에 투명성을 보장합니다.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {strengths.map((s) => (
                <div
                  key={s.title}
                  className="group p-6 border border-neutral-200 rounded-xl hover:border-point-400 hover:bg-point-50/30 transition-all duration-500 ease-out hover:-translate-y-2 cursor-pointer"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-navy-900 text-point-400 mb-4 group-hover:bg-point-500 group-hover:text-white transition-colors">
                    <i className={`${s.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-hero text-navy-900 text-lg mb-2">{s.title}</h3>
                  <p className="text-sm text-neutral-600 leading-relaxed">{s.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}